import { createReducer, on } from '@ngrx/store';

import * as Actions from './check-bilanci.actions';

export const CHECK_CHIUSURE_FEATURE_KEY = 'check-bilanci';

export interface CheckBilanciPartialState {
  readonly [CHECK_CHIUSURE_FEATURE_KEY]: CheckBilanciState;
}

export interface CheckBilanciState {
  esercizioChecked: boolean;
  esercizioClosed: boolean;
  esercizioEnteId: number | null;
  esercizioAnno: number | null;
  consolidatoChecked: boolean;
  consolidatoExists: boolean;
  consolidatoClosed: boolean;
  consolidatoEnteId: number | null;
  consolidatoAnno: number | null;
  riepilogoChecked: boolean;
  datiRiepilogoModificati: boolean;
}

const initialState: CheckBilanciState = {
  esercizioChecked: false,
  esercizioClosed: false,
  consolidatoChecked: false,
  consolidatoExists: false,
  consolidatoClosed: false,
  consolidatoAnno: null,
  consolidatoEnteId: null,
  esercizioAnno: null,
  esercizioEnteId: null,
  riepilogoChecked: false,
  datiRiepilogoModificati: false,
};

export const reducer = createReducer(
  initialState,
  on(
    Actions.checkConsolidatoSuccess,
    (s, { exists, closed, anno, enteId }) => ({
      ...s,
      consolidatoChecked: true,
      consolidatoExists: exists,
      consolidatoClosed: closed,
      consolidatoAnno: anno,
      consolidatoEnteId: enteId,
    })
  ),
  on(Actions.checkEsercizioChiusoSuccess, (s, { closed, anno, enteId }) => ({
    ...s,
    esercizioChecked: true,
    esercizioClosed: closed,
    esercizioAnno: anno,
    esercizioEnteId: enteId,
  })),
  on(Actions.checkDatiRiepilogoModificatiSuccess, (s, { modificati }) => ({
    ...s,
    riepilogoChecked: true,
    datiRiepilogoModificati: modificati,
  }))
);
